import { Control } from "rete";
import InputComponent from "./input-component";

export class InputControl extends Control {
  constructor(emitter, key, type, readonly) {
    super(key);
    this.component = InputComponent;
    this.props = {
      emitter,
      ikey: key,
      type,
      readonly
    };
  }

  setValue(value) {
    this.vueContext.value = value;
  }
}
